import { render, staticRenderFns } from "./BuySellFarmDetail.vue?vue&type=template&id=46deab91&scoped=true"
import script from "./BuySellFarmDetail.vue?vue&type=script&lang=js"
export * from "./BuySellFarmDetail.vue?vue&type=script&lang=js"
import style0 from "./BuySellFarmDetail.vue?vue&type=style&index=0&id=46deab91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46deab91",
  null
  
)

export default component.exports